/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';

export interface DeleteServiceProviderAnnouncement$Params {

/**
 * The announcement key
 */
  announcementKey: KeyType;
}

export function deleteServiceProviderAnnouncement(http: HttpClient, rootUrl: string, params: DeleteServiceProviderAnnouncement$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteServiceProviderAnnouncement.PATH, 'delete');
  if (params) {
    rb.path('announcementKey', params.announcementKey, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteServiceProviderAnnouncement.PATH = '/service-provider/announcements/{announcementKey}';
